import { render, staticRenderFns } from "./Damages.vue?vue&type=template&id=32210ab0&scoped=true"
import script from "./Damages.vue?vue&type=script&lang=js"
export * from "./Damages.vue?vue&type=script&lang=js"
import style0 from "./Damages.vue?vue&type=style&index=0&id=32210ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32210ab0",
  null
  
)

export default component.exports